import request from './request';
/**
 * 查询优惠券列表信息
 */
export function getCouponList(params) {
    return request('/coupon/list', {
        method: 'POST',
        params,
    });
}

/**
 * 创建优惠券
 */
export function createCoupon(params) {
    return request('/coupon', {
        method: 'POST',
        params,
    });
}

/**
 * 重新提交审核优惠券
 */
export function reAudit(params) {
    return request(`/coupon/${params.id}`, {
        method: 'PUT',
        params,
    });
}

/**
 * 获取优惠券详情
 */
export function getCouponDetail(params) {
    return request(`/coupon/${params.couponId}`, {
        method: 'GET',
    });
}

/**
 * 作废优惠券
 */
export function voidCoupon(params) {
    return request(`/coupon/cancel/${params.id}/`, {
        method: 'PUT',
        params,
    });
}

// 获取优惠券核销列表
export function getCouponVerificateList(params) {
    return request('/coupon/verificate/list', {
        method: 'POST',
        params,
    });
}

// 核销优惠券
export function verificateCoupon(params) {
    return request(`/coupon/verificate/${params}`, {
        method: 'PATCH',
        params,
    });
}

// 获取优惠券核销列表导出
export function getCouponVerificateExport() {
    return '/coupon/verificate/export';
}

// 获取用户已领取的优惠券详情
export function getCouponVerificateDetail(params) {
    return request(`/coupon/received/${params}`, {
        method: 'GET',
        params,
    });
}

// 获取核销优惠券详情
export function getCouponVerificate(params) {
    return request(`/coupon/verificate/detail/${params.id}`, {
        method: 'GET',
    });
}

// 作废优惠券
export function cancelCoupon(params) {
    return request(`/coupon/verificate/cancel/${params}`, {
        method: 'PATCH',
    });
}

// 优惠券详情-使用信息分页列表
export function getUseInfo(params) {
    return request(`/coupon/activity-coupon/${params.id}`, {
        method: 'GET',
        params: {
            pageSize: params.pageSize,
            pageNum: params.pageNum,
        },
    });
}

// 发券-自定义客户-车架号校验
export function checkVin(params) {
    return request('/vehicle/check-vin', {
        method: 'POST',
        params,
    });
}

// 获取店铺下的所有优惠券名称
export function getCouponName() {
    return request('/coupon/list-for-orgid', {
        method: 'GET',
    });
}

// 优惠券详情-使用信息-导出名单分页加导出
export function getExportList(params) {
    return request(`/coupon/activity-coupon-export-page/${params.activityId}`, {
        method: 'GET',
        params: {
            pageNum: params.pageNum,
            pageSize: params.pageSize,
            uploadFlag: params.uploadFlag,
            couponId: params.couponId,
        },
    });
}

// 获取优惠券核销列表--tab统计
export function getListCount() {
    return request('/coupon/verificate/list-count', {
        method: 'POST',
    });
}

/**
 * 优惠券支付记录列表
 */
export function getPayList(params) {
    return request('/coupon/pay/list', {
        method: 'POST',
        params,
    });
}

/**
 * 获取店铺汽油兑换金额
 */
export function getOilRatio() {
    return request('/coupon/oil/exchange-ratio', {
        method: 'GET',
    });
}

/**
 * 付费券协议授权是否授权
 */
export function getAuth() {
    return request('/coupon/get-auth', {
        method: 'GET',
    });
}

/**
 * 付费券协议授权
 */
export function setAuth(params) {
    return request('/coupon/auth', {
        method: 'POST',
        params,
    });
}

/**
 * 服务项目配置列表
 */
export function serviceItems() {
    return request('/service-item/list', {
        method: 'GET',
    });
}
/**
 * 优惠券适用门店查询
 */
export function getCouponOrgById(couponId) {
    return request(`/coupon/coupon-org/${couponId}`, {
        method: 'GET',
    });
}

/**
 * 编辑优惠券适用门店
 */
export function updateCouponStore(params) {
    return request('/coupon/org/update', {
        method: 'PUT',
        params,
    });
}

/**
 * 获取优惠券来源总数
 */
export function getOrgTypeCount() {
    return request('/coupon/orgType/count', {
        method: 'POST',
    });
}
